import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Privacidad } from './pages/Privacidad';
import { Terminos } from './pages/Terminos';
import { Reembolsos } from './pages/Reembolsos';
import { Contacto } from './pages/Contacto';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/privacidad" element={<Privacidad data-id="element-5" />} data-id="element-4" />
        <Route path="/terminos" element={<Terminos data-id="element-7" />} data-id="element-6" />
        <Route path="/reembolsos" element={<Reembolsos data-id="element-9" />} data-id="element-8" />
        <Route path="/contacto" element={<Contacto data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}